/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react';
import { HocOptions } from '../common/generic-hoc.types';
import { StylesProps, ThemeType } from '../../theme/jss-types';
import TableModal from '../table-modal/tableModal';
import { fetchSupplementaryServices } from '../../network/supp-services.api';
import {
    getColumnsForSupplementaryServices,
    defaultColumnsForSupplementaryServices,
} from '../supplementary-services/supplementaryServicesColumn';
import { PageKeys } from './consignment.types';
import { consignemtStyles } from './consignment.styles';
import Paginator from '../common/paginator';
import moment, { Moment } from 'moment';
import ConsignmentDetails from './consignment-details-new';
import ExcelUpload from './excel-upload';
import PrintHistory from './print-history';
import Settings from '../settings/settings';
import CancellationModal from './consignment-cancel';
import FailureList from './cancellation-failure';
import RescheduleModal, { RescheduleAction, RescheduleConsignment } from './consignment-reschedule';
import {
    Button,
    DatePicker,
    Dropdown,
    message,
    Table,
    Menu,
    Select,
    Tooltip,
    Tabs,
    Modal,
    Image,
    Popover,
    Upload,
    Row,
    Col,
    Typography,
    Input,
    Divider,
} from 'antd';
import {
    EditOutlined,
    EyeOutlined,
    PrinterOutlined,
    InfoCircleOutlined,
    ReloadOutlined,
    SettingOutlined,
    EnvironmentOutlined,
    UploadOutlined,
    InfoCircleFilled,
    LinkOutlined,
    DeleteOutlined,
    PlusOutlined,
    MoreOutlined,
    FilterOutlined,
    DownloadOutlined,
    CheckCircleOutlined,
    ExclamationCircleFilled,
    CalendarOutlined,
} from '@ant-design/icons';
import {
    dateKeys,
    // PageOptions,
    prettyMovementTypes,
    ConsignmentBuckets,
    defaultConsignmentColumns,
    dateKeysPickup,
    dateKeysWithStringTimestamp,
    dateColumnKeys,
    allowedEditStatus,
} from './consignments.constants';
import StatusPrettyName from './status-pretty-name';
import {
    getLabelType,
} from '../labels/labels.constants';
import {
    downloadConsignments,
    downloadConsignments4X6Files,
    printConsignment,
    printConsignmentInvoice,
    printBulkConsignmentInvoice,
    printConsignment4x6,
    printConsignment4x6Domestic,
    printInvoice,
    getPublishedLabels,
    printBulkLabel,
    downloadPickupProof,
    downloadDeliveryProof,
    downloadPickupConfirmationProof,
    downloadDeliveryConfirmationProof,
    printBulkLabelWithPx,
    markConsignmentAsPaid,
} from '../../network/consignments.api';
import {
    Master,
    ConsignmentColumn,
    ConsignmentBucketKeys,
    FilterMetadata,
} from '../../types/master-data-types';
import {
    isEmpty,
    uniqBy,
    get,
    groupBy,
} from 'lodash';
import Helper from '../../library/Helper';
import MoreFilters from './more-filters-new';
import { loadConsignments, getMoreFilters } from '../../actions/consignment-actions';
import {
    applyFilters,
    setFilters,
    setPagination,
} from '../../actions/generic-action';
import { bindActionCreators } from 'redux';
import {
    Buckets,
    NextOrPrev,
    Pagination,
    FilterType,
} from '../../library/Types';
import { ReduxStore } from '../../reducers/redux.types';
import { RouteChildrenProps } from 'react-router';
import {
    getConsignmentsRoute,
    getPluginOrdersRoute,
    getDownloadsRoute,
    getExcelUploadRoute,
    getPrintHistoryRoute,
} from '../../routing/routing-helper';
import GenericHoc from '../common/generic-hoc';
import { paginationOptions, Routes } from '../../library/constants';
import ProofOfDelivery from './pod-details';
import { allowedColumns } from 'library/globals';
import EditNotes from './edit-notes';
import { useTranslation } from 'react-i18next';
import SchedulePickupModal from './consignment-schedule-pickup';
import GalleryModal from '../common/gallery-modal';
import SingleConsignment from 'components/create-consignment/single-consignment';
import SingleConsignmentNew from 'components/create-consignment/single-cn-creation/single-consignment-new';
import { getUploadFileUrls, postUploadFiles, uploadImageToS3 } from 'network/common.api';
import PluginOrders from './plugin-orders';
import {
    getFilters,
    formatDateTime,
    getFilterMetadataInOrder,
    buildDeliverySlotTimeFilter,
} from './consignments.helper';
import DocumentDetailsModal from './document-details-modal';
import { PAGE_NAMES, PageData } from 'types/page.types';
import { fetchViewData } from 'actions/objectpage-actions';
import BulkPrint from './bulk-print';
import FixedHeaderTable from 'components/common/FixedHeaderTable/FixedHeaderTable';
import ConsignmentPageMobile from './consignment-page-mobile';
import useIsMobile from 'hooks/useIsMobile';
import { getListView } from './view-registry';
import ViewToggle from './views/grid_view_1/list/view-toggle';

const { Text } = Typography;
const menuStyle: React.CSSProperties = {
    padding: 12,
    borderBottom: '1px solid #CCCCCC',
    fontWeight: 'bold',
    fontSize: 12,
};

const ActionMenuStyle: React.CSSProperties = {
    padding: 12,
    borderRadius: 6,
    gap: 16,
    fontWeight: '600',
    fontSize: 14,
    backgroundColor: 'white',
};
interface ConsignmentProps
    extends StylesProps<ReturnType<typeof consignemtStyles>>, RouteChildrenProps {
    master: Master;
    loadconsignments: () => void;
    setfilters: (bucketId: Buckets.CONSIGNMENTS, filters: any) => void;
    applyfilters: (bucketId: Buckets.CONSIGNMENTS) => void;
    setpagination: (bucketId: Buckets.CONSIGNMENTS, newPagination: Partial<Pagination>) => void;
    fetchviewdata: (data: { viewIndex: number, pageName: string, sectionIndex: number, viewId: string }) => void;
    filters: Record<string, any>;
    loading: boolean;
    consignments: any;
    summary: any;
    pagination: Pagination;
    defaultFilters: Record<string, any>;
    uiTheme: ThemeType;
    consignmentPageData: PageData;
}

interface GalleryModalData {
    images: string[];
    videos: string[];
}

interface TextModalData {
    text: string;
    title: string;
}

interface DocumentDetails {
    document_type: string; existing_document_details: { type: string, url: string }[]; new_files_uploaded: any;
}

interface DocumentDetailsUploadPayload {
    type: string,
    url: string,
}
interface RowData {
    url: string,
    new_uploaded: boolean
}

const {
    useState,
    useEffect,
    useMemo,
} = React;

const ConsignmentPage = (props: ConsignmentProps) => {
    const {
        master,
        classes,
        filters,
        setfilters,
        applyfilters,
        fetchviewdata,
        loading,
        consignments,
        loadconsignments,
        summary,
        pagination,
        setpagination,
        history,
        defaultFilters,
        uiTheme,
        consignmentPageData,
    } = props;
    const { t, i18n } = useTranslation();
    const enable_customer_config = master?.parts_to_show?.enable_customer_config || false;
    const enable_shopify_integration = master?.parts_to_show?.enable_shopify_integration || false;
    const softdataCreationUnifiedFlow = master?.parts_to_show?.softdata_creation_unified_flow_enabled;
    const useMariaDb = get(master, 'config.customer_portal_config.use_mariadb_in_consignment_view');
    const allowedEditStatusFromConfig = master?.config?.customer_portal_config?.allowed_consignment_edit_status;
    const effectiveAllowedEditStatus = allowedEditStatusFromConfig || allowedEditStatus;

    const customerProperties = master?.properties;
    let restrictPrintInvoice = false;
    let showCancelButton = true;
    let showShipmentLabelA4 = true;
    let showShippingLabelA6 = true;
    let showShippingLabel4X6 = true;
    let showMultipleCnSection = true;
    let showTrackingIcon = true;
    let showAllowMarkAsPaid = false;
    let useThirdPartyLabel = false;
    let pickupProofEnabled = false;
    let deliveryProofEnabled = false;
    let deliveryConfirmationProofEnabled = false;
    let pickupConfirmationProofEnabled = false;
    let useThirdPartyInvoice = false;
    if (customerProperties && enable_customer_config) {
        restrictPrintInvoice = !customerProperties?.print_invoice;
        showCancelButton = customerProperties?.cn_cancel;
        showShipmentLabelA4 = customerProperties?.a4_shipping_label;
        showShippingLabelA6 = customerProperties?.a6_shipping_label;
        showShippingLabel4X6 = customerProperties?.x46_shipping_label;
        showMultipleCnSection = customerProperties?.cn_multiple_creation;
        showTrackingIcon = customerProperties?.tracking_icon;
        showAllowMarkAsPaid = customerProperties?.allow_mark_as_paid;
        useThirdPartyLabel = customerProperties?.use_third_party_label;
        useThirdPartyInvoice = customerProperties?.use_third_party_invoice;
        pickupProofEnabled = customerProperties?.enable_pickup_proof_documents;
        deliveryProofEnabled = customerProperties?.enable_delivery_proof_documents;
        deliveryConfirmationProofEnabled = customerProperties?.enable_delivery_confirmation_documents;
        pickupConfirmationProofEnabled = customerProperties?.enable_pickup_confirmation_documents;
    }

    const isMobile = useIsMobile();
    const getInitialPage = (): PageKeys => {
        switch (history.location.pathname) {
            case `/${Routes.PLUGIN_ORDERS}`:
                if (!enable_shopify_integration) history.push(`/${Routes.CONSIGNMENTS}`);
                return 'PluginOrders';
            case `/${Routes.EXCEL_UPLOAD}`: return 'ExcelUpload';
            case `/${Routes.PRINT_HISTORY}`: return 'PrintHistory';
            case `/${Routes.CONSIGNMENTS}`:
            default: return 'Consignments';
        }
    };

    const getReferenceNumberFromUrl = () => {
        const { location } = history;
        const { pathname } = location;
        if (pathname.includes(Routes.CONSIGNMENT_DETAILS)) {
            const url = pathname.split('/');
            return url[3];
        }
        return undefined;
    };

    const [pageSelected, setPageSelected] = useState<PageKeys>(getInitialPage());
    const [details, setDetails] = useState<string | undefined>(
        getReferenceNumberFromUrl(),
    );
    const [settingsVisible, setSettingsVisible] = useState<boolean>(false);
    const [moreFilterVisible, setMoreFiltersVisible] = useState<boolean>(false);
    const [downloading, setDownloading] = useState<boolean>(false);
    const [consignmentsSelected, setConsignmentSelected] = useState<string[]>([]);
    const [bulkPrinting, setBulkPrinting] = useState<boolean>(false);
    const [toggle, setToggle] = React.useState<boolean>(true);

    const customerPortalConfig = master?.config?.customer_portal_config as any;
    const viewId = customerPortalConfig?.page_views?.consignment_list?.view_id;
    const viewIdMobile = customerPortalConfig?.page_views?.consignment_list?.view_id_mobile;
    const viewIdToUse = isMobile ? (viewIdMobile || viewId) : viewId;

    const [viewMode, setViewMode] = React.useState<string | null | undefined>(viewIdToUse);
    const [podConsignment, setPodConsignment] = React.useState<any>();
    const [dateType, setDateType] = React.useState(dateKeys[0]);
    const [allPublishLabels, setPublishedLabels] = React.useState<any[]>([]);
    const [notesReferenceNumber, setNotesReferenceNumber] = React.useState<any>(null);
    const [notesValue, setNotesValue] = React.useState<any>(undefined);
    const [scheduleVisible, setScheduleVisible] = React.useState<boolean>(false);
    const [filterHeight, setFilterHeight] = React.useState(0);
    const filtersRef = React.useRef<HTMLDivElement>(null);
    const [successVisible, setSuccessVisible] = useState(false);
    const [inputFilterVal, setInputFilterVal] = useState<string>('');

    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    const [rowupload, setRowUpload] = React.useState<any>(null);

    const [cancelVisible, setCancelVisible] = useState<any>({
        visible: false,
        action: '',
    });
    const [failures, setFailures] = React.useState<any>({
        visible: false,
        list: [],
    });
    const [rescheduleVisible, setRescheduleVisible] = useState<{
        visible: boolean;
        action?: RescheduleAction;
        consignments?: RescheduleConsignment[];
    }>({ visible: false });
    const [isTextModalVisible, setIsTextModalVisible] = React.useState(false);
    const [isSupplementaryServiceTable, setIsSupplementaryServiceTable] = React.useState<any>(false);
    const [supplementaryServiceData, setSupplementaryServiceData] = React.useState<any>([]);
    const [textModalData, setTextModalData] = React.useState<TextModalData>({ text: '', title: '' });
    const [isGalleryModalVisible, setIsGalleryModalVisible] = React.useState(false);
    const [galleryModalData, setGalleryModalData] = React.useState<GalleryModalData>({ images: [], videos: [] });
    const [imageUrl, setImageUrl] = React.useState<string| null>(null);
    const [editFormVisible, setFormVisible] = React.useState<boolean>(false);
    const [editData, setEditData] = React.useState<any>(null);
    const [confirmationModalVisible, setConfirmationModalVisible] = useState<boolean>(false);
    const [markAsPaidReferenceNumber, setMarkAsPaidReferenceNumber] = useState<string>('');

    const { config, parts_to_show } = master;
    const { bucketSelected } = filters;
    // to subtract banner height from table
    const enableCodefree = parts_to_show?.enable_code_free_label_generation || false;
    const showBucketCount = master?.config?.customer_portal_config?.fetch_customer_portal_bucket_count;
    const showPickupScheduleButton = master?.config?.customer_portal_config?.show_pickup_request_button;
    const isCancelAllowed = master?.config?.cancellation_config?.allow_customer_level_cancellation;
    const showReschedule = Boolean(parts_to_show?.show_reschedule);
    // eslint-disable-next-line max-len
    const isEditAllowed = master?.config?.customer_portal_ops_config?.consignment_flow_type_config?.config_value?.allow_consignment_edit;
    const documentConfig = master?.config?.customer_portal_ops_config?.document_config?.config_value;
    const validDocumentTypes = documentConfig?.allowed_document_types_customer_portal || [];
    const [showUploadModal, setShowUploadModal] = useState<boolean>(false);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [modalRow, setModalRow] = useState<any>(null);
    const documentIdToNameMapping = master?.config?.available_document_types_id_to_name_mapping || {};
    const maxFiles = config?.allow_multiple_file_upload_in_customer_portal?.number_of_documents_allowed_in_consignment;
    const [showBulkPrintModal, setShowBulkPrintModal] = useState<boolean>(false);
    const useBulkPrintModal = true;
    const currencySymbol = master?.config?.currency_symbol || '';

    const [documentDetails, setDocumentDetails] = useState<any>([]);

    const [selectedSearchType, setSelectedSearchType] = useState<string>('referenceNumberList');
    const statusOptions = config?.filter_metadata?.find((item) => {
        return item.id === 'statusList';
    })?.options || [];

    const dashboardFilterMetadata = useMemo(() => {
        if (!config?.filter_list_by_bucket) {
            return [];
        }
        const bucketKey = (consignmentPageData ? 'customer_portal_all' : bucketSelected) as ConsignmentBucketKeys;
        type DashboardFilterConfig = { id: string; show_on_main_dashboard?: boolean };
        const bucketFilters = (config.filter_list_by_bucket[bucketKey] || []) as DashboardFilterConfig[];

        let orderedFilters: DashboardFilterConfig[] = bucketFilters;
        if (consignmentPageData) {
            const viewData = consignmentPageData?.getViewData(bucketSelected);
            const visibleFilterIds = viewData?.visibleFilterList?.map((filter) => filter.id) || [];
            if (visibleFilterIds.length) {
                orderedFilters = visibleFilterIds
                    .map((id) => bucketFilters.find((filter) => filter.id === id))
                    .filter((filter): filter is DashboardFilterConfig => Boolean(filter));
            }
        }

        const dashboardFilterIds = orderedFilters
            .filter((filter) => filter.show_on_main_dashboard)
            .map((filter) => filter.id);

        return getFilterMetadataInOrder(config, dashboardFilterIds);
    }, [config, bucketSelected, consignmentPageData]);

    // Sync selectedSearchType and inputFilterVal with filters (for toggle)
    React.useEffect(() => {
        if (viewIdToUse) {
            setSelectedSearchType(
                filters?.customerReferenceNumberList ? 'customerReferenceNumberList' : 'referenceNumberList',
            );
            setInputFilterVal(
                filters?.customerReferenceNumberList || filters?.referenceNumberList || '',
            );
        }
    }, [filters?.customerReferenceNumberList, filters?.referenceNumberList]);

    React.useEffect(() => {
        const currentDocDetails: DocumentDetails[] = [];
        const recordDocumentDetails = rowupload?.document_details || [];
        const documentTypeWiseDetails = groupBy(recordDocumentDetails, 'type');
        Object.keys(documentTypeWiseDetails).forEach((key) => {
            const data = documentTypeWiseDetails[key];
            currentDocDetails.push({ document_type: key, existing_document_details: data, new_files_uploaded: [] });
        });
        setDocumentDetails(currentDocDetails);
    }, [rowupload]);

    const [imageUploadLoading, setImageUploadLoading] = useState<boolean>(false);

    const renderDocumentTypeWiseFile = (currentDocumentTypeObject: any, index: number) => {
        const currentDocumentType = currentDocumentTypeObject.document_type;
        const existingDocumentDetails = currentDocumentTypeObject.existing_document_details || [];
        const newDocumentsInCurrentRow = currentDocumentTypeObject.new_files_uploaded || [];

        const availableDocumentTypesList = validDocumentTypes.map(
            (documentType: any) => {
                return {
                    label: documentIdToNameMapping[documentType],
                    value: documentType,
                };
            },
        );

        let currentTotalFiles = 0;
        documentDetails.forEach((data: any) => {
            currentTotalFiles += data?.new_files_uploaded?.length || 0;
            currentTotalFiles += data?.existing_document_details?.length || 0;
        });

        const handleDocumentTypeChange = (value: string) => {
            const newDocumentDetails = [...documentDetails];
            newDocumentDetails[index].document_type = value;
            setDocumentDetails(newDocumentDetails);
        };

        const handleChange = (info: any) => {
            const file = info.file;
            if (file && file.size / 1024 / 1024 < 2) {
                const newDocumentDetails = [...documentDetails];
                newDocumentDetails[index].new_files_uploaded = info.fileList;
                setDocumentDetails(newDocumentDetails);
            }
        };

        const handleRemove = (file: any) => {
            const newDocumentDetails = [...documentDetails];
            newDocumentDetails[index].new_files_uploaded = newDocumentsInCurrentRow.filter((f: any) => f.uid !== file.uid);
            setDocumentDetails(newDocumentDetails);
        };

        const removeRow = (rowIndex: number) => {
            const newDocumentDetails = [...documentDetails];
            newDocumentDetails.splice(rowIndex, 1);
            setDocumentDetails(newDocumentDetails);
        };

        const removeUploadedFile = (file: RowData) => {
            const newDocumentDetails = [...documentDetails];
            if (file.new_uploaded) {
                const filteredFiles = newDocumentsInCurrentRow.filter((f: any) => f.name !== file.url);
                newDocumentDetails[index].new_files_uploaded = filteredFiles;
            } else {
                const filteredFiles = existingDocumentDetails.filter(
                    (doc: { type: string, url: string }) => doc.url !== file.url,
                );
                newDocumentDetails[index].existing_document_details = filteredFiles;
            }
            setDocumentDetails(newDocumentDetails);
        };

        const rows = [];
        const totalFiles: RowData[] = [];
        newDocumentsInCurrentRow.map((newDocument: any) => totalFiles.push({ url: newDocument.name, new_uploaded: true }));
        existingDocumentDetails.map(
            (document: { type: string, url: string }) => totalFiles.push({ url: document.url, new_uploaded: false }),
        );
        for (let i = 0; i < totalFiles.length; i += 3) {
            const rowData = totalFiles.slice(i, i + 3);
            rows.push(rowData);
        }

        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        marginBottom: '20px',
                        marginTop: '10px',
                        alignItems: 'center',
                    }}
                >
                    <div className={classes.grayCircle}>{index + 1}</div>
                    <Select
                        style={{ width: '40%', marginRight: '20px' }}
                        placeholder="Choose Document Type"
                        value={currentDocumentType}
                        onChange={handleDocumentTypeChange}
                        options={availableDocumentTypesList}
                    />
                    <Upload
                        name="file"
                        disabled={
                            !currentDocumentType || currentTotalFiles >= maxFiles
                        }
                        fileList={newDocumentsInCurrentRow}
                        onChange={handleChange}
                        onRemove={handleRemove}
                        multiple
                        beforeUpload={(file) => {
                            const isLt2M = file.size / 1024 / 1024 < 2;
                            if (!isLt2M) {
                                message.error('File must be smaller than 2MB!');
                            }
                            return isLt2M;
                        }}
                        showUploadList={false}
                    >
                        <Button
                            disabled={
                                !currentDocumentType || currentTotalFiles >= maxFiles
                            }
                            icon={<UploadOutlined />}
                        >
                            Upload Files
                        </Button>
                    </Upload>
                    <div style={{ flexGrow: '1' }} />
                    <DeleteOutlined
                        style={{ color: '#666666', fontSize: '22px' }}
                        onClick={() => removeRow(index)}
                    />
                </div>
                {rows.length > 0 && (
                    <div style={{ marginLeft: '52px' }}>
                        <>
                            {rows.map((row) => (
                                <Row
                                    gutter={[16, 16]}
                                    style={{ marginBottom: '20px' }}
                                >
                                    {row.map((item: RowData) => (
                                        <Col key={item.url} span={8} style={{ maxHeight: '22px', height: '22px' }}>
                                            <div key={item.url} className={classes.customFlex}>
                                                <a
                                                    href={item.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={
                                                        item?.new_uploaded
                                                            ? {
                                                                pointerEvents: 'none',
                                                                cursor: 'not-allowed',
                                                            }
                                                            : {}
                                                    }
                                                >
                                                    <div key={item.url} className={classes.customFlex}>
                                                        <LinkOutlined
                                                            style={{
                                                                color: '#666666',
                                                            }}
                                                        />
                                                        <Text
                                                            style={{
                                                                textAlign: 'center',
                                                                marginLeft:
                                                                    '10px',
                                                                marginRight:
                                                                    '10px',
                                                                maxWidth: '80%',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                width: '135px',
                                                                textOverflow:
                                                                    'ellipsis',
                                                                color: item.new_uploaded
                                                                    ? '#666666'
                                                                    : '#006EC3',
                                                            }}
                                                        >
                                                            {item.url}
                                                        </Text>
                                                    </div>
                                                </a>
                                                <DeleteOutlined
                                                    style={{ color: '#666666' }}
                                                    onClick={() => removeUploadedFile(item)}
                                                />
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            ))}
                        </>
                    </div>
                )}
            </>
        );
    };

    const handlemodalclose = () => {
        setDocumentDetails([]);
        setShowUploadModal(false);
        setRowUpload(null);
    };

    const fetchConsignmentData = (bucket: string) => {
        if (consignmentPageData && consignmentPageData.metadata.sectionList.length > 0) {
            const viewIndex = consignmentPageData.metadata.sectionList.flat().findIndex(
                (v) => v.id === bucket,
            );
            if (viewIndex > -1) {
                const sectionIndex = (viewIndex + 1) % consignmentPageData.metadata.sectionList.length;
                const viewData = consignmentPageData.metadata.sectionList[sectionIndex][viewIndex];
                fetchviewdata({
                    viewIndex,
                    pageName: PAGE_NAMES.CONSIGNMENTS,
                    sectionIndex,
                    viewId: viewData.id,
                });
            }
        }
    };

    const handleUploadImageSubmit = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setImageUploadLoading(true);

        // computing total new files uploaded
        const newFileList: any = [];
        documentDetails.forEach((data: any, index: number) => {
            let newFiles = data.new_files_uploaded || [];
            const documentType = data.document_type;
            newFiles = newFiles.map((newFile: any) => {
                return {
                    ...newFile,
                    document_type: documentType,
                    index,
                };
            });
            newFileList.push(...newFiles);
        });

        // promise to upload new file to s3 by computing its url from backend first
        const promises = newFileList.map(async (file: any) => {
            const bodyGetUrl = {
                content_type: file.type,
                reference_number: rowupload.reference_number,
            };

            const response = await getUploadFileUrls(bodyGetUrl);
            const upload = await uploadImageToS3(
                new Blob([file.originFileObj as BlobPart], {
                    type: file?.type,
                }),
                response?.data?.result?.imageSignedUrl,
                file?.type,
            );
            if (!upload.isSuccess) {
                message.error('Could not upload file');
            }
            const s3UrlToReturn = upload.isSuccess ? response?.data?.result?.imageUrl : null;
            return { url: s3UrlToReturn, document_type: file.document_type, index: file.index };
        });

        try {
            const fileUrls = await Promise.all(promises);
            const newlyUploaded = fileUrls.filter((file: any) => !!file.url);
            const newlyUploadedFiles = groupBy(newlyUploaded, 'index');

            // generating api payload for each document type
            const documentDetailsToUpload: DocumentDetailsUploadPayload[] = [];

            documentDetails.forEach((data: any, index: number) => {
                const documentType = data.document_type;
                const existingDocumentDetails = data.existing_document_details || [];
                if (documentType) {
                    const newFileObjects = newlyUploadedFiles[index] || [];
                    [...existingDocumentDetails, ...newFileObjects].forEach((file) => {
                        documentDetailsToUpload.push({
                            type: documentType,
                            url: file.url,
                        });
                    });
                }
            });
            const response = await postUploadFiles({
                documentDetails: documentDetailsToUpload,
                referenceNumber: rowupload.reference_number,
            });
            if (response.isSuccess) {
                message.success('Files uploaded successfully');
                fetchConsignmentData(filters.bucketSelected);
                setfilters(Buckets.CONSIGNMENTS, filters);
                applyfilters(Buckets.CONSIGNMENTS);
            } else {
                message.error(response.errorMessage || 'Could not upload files');
            }
            handlemodalclose();
        } catch (error) {
            message.error(error);
            handlemodalclose();
        }
        setImageUploadLoading(false);
    };

    const handleAddDocumentType = () => {
        const newDocumentDetails = [...documentDetails];
        newDocumentDetails.push({ document_type: '', document_urls: [] });
        setDocumentDetails(newDocumentDetails);
    };
    const showShippingLabelButton = showShipmentLabelA4 || showShippingLabelA6 || showShippingLabel4X6 || enableCodefree;

    const handleBucketChange = (bucket: string) => {
        if (bucket === filters.bucketSelected) {
            return;
        }
        const newFilters = {
            ...filters,
            bucketSelected: bucket,
        };
        fetchConsignmentData(bucket);
        setfilters(Buckets.CONSIGNMENTS, newFilters);
        applyfilters(Buckets.CONSIGNMENTS);
    };

    useEffect(() => {
        if (pageSelected !== 'Consignments') {
            return;
        }
        if (consignmentPageData && consignmentPageData.hasViews() && bucketSelected === 'customer_portal_all') {
            handleBucketChange(consignmentPageData.metadata.sectionList[0][0].id);
        }
        loadconsignments();
    }, [filters, toggle]);

    React.useEffect(() => {
        const handleResize = () => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    });

    useEffect(() => {
        if (filtersRef?.current?.clientHeight !== filterHeight) {
            setFilterHeight(filtersRef?.current?.clientHeight || 0);
        }
    }, [dimensions]);

    const getAllPublishedLabels = async () => {
        const response = await getPublishedLabels();
        if (response.isSuccess) {
            const validateList = (label: any) => label.is_active;
            const updatedLabels = response.data?.metadata_list?.filter(validateList);
            if (updatedLabels && Array.isArray(updatedLabels) && updatedLabels.length) {
                setPublishedLabels(updatedLabels);
            }
        } else {
            const errorMessage = response.errorMessage || 'Something went wrong';
            message.error(errorMessage);
        }
    };

    useEffect(() => {
        getAllPublishedLabels();
    }, []);

    const getConginmentDetailsUrl = (referenceNumber: string) => {
        return `/${Routes.CONSIGNMENT_DETAILS}/${referenceNumber}?view=${bucketSelected}`;
    };

    const menuItemBaseStyle = {
        borderRadius: 4,
        fontWeight: '600',
        cursor: 'pointer',
        color: 'black',
    };

    const goToDetailsPage = (row: any) => {
        setDetails(row?.reference_number);
        history.push(getConginmentDetailsUrl(row.reference_number));
    };

    const renderText = (text: string, row: any) => {
        return (
            <div
                className={classes.cellValue}
                style={{
                    color: '#1659CB',
                }}
                onClick={() => goToDetailsPage(row)}
            >
                {text}
            </div>
        );
    };

    const handlePrintLabel = (fileBuffer: any, fileName: string) => {
        if (fileBuffer.isSuccess) {
            const name = fileBuffer.filename || fileName;
            Helper.downloadFileData(
                fileBuffer.data,
                name,
                true,
                'pdf',
            );
            message.success('Success');
        } else {
            message.error('Unable to fetch label at the moment. Please try again after sometime');
        }
        setBulkPrinting(false);
    };

    const handlePrint = async (referenceNumbers: any, isSmall: boolean, fileName: string) => {
        setBulkPrinting(true);
        const fileBuffer = await printConsignment({
            isSmall,
            referenceNumbers,
            useThirdPartyLabel,
        });
        handlePrintLabel(fileBuffer, fileName);
    };

    const handleThirdPartyInvoicePrinting = async (referenceNumber: any, fileName: string) => {
        setBulkPrinting(true);
        const payload = {
            referenceNumber,
            useThirdPartyInvoice,
        };
        const fileBuffer = await printConsignmentInvoice(payload);
        handlePrintLabel(fileBuffer, fileName);
    };

    const handlePrintLabel4X6 = (fileBuffer: any, fileName: string) => {
        if (fileBuffer.isSuccess) {
            const name = fileBuffer.filename || fileName;
            Helper.downloadFileData(
                fileBuffer.data,
                name,
                true,
                'pdf',
            );
            message.success('Success');
        } else {
            message.error('Failed to generate PDF!');
        }
    };

    const handlePrint4X6 = async (referenceNumbers: any) => {
        setBulkPrinting(true);
        const fileUrls = await printConsignment4x6({
            referenceNumbers,
        });
        fileUrls?.data?.forEach((fileUrlsList: any) => {
            fileUrlsList?.forEach(async (fileUrl: any) => {
                if (fileUrl && fileUrl.length) {
                    const fileBuffer = await downloadConsignments4X6Files(fileUrl);
                    const fileUrlSplit = fileUrl.split('/');
                    handlePrintLabel4X6(fileBuffer, fileUrlSplit[fileUrlSplit.length - 1]);
                }
            });
        });
        setBulkPrinting(false);
    };

    const handlePrint4X6Domestic = async (referenceNumbers: any, fileName: string) => {
        setBulkPrinting(true);
        const fileBuffer = await printConsignment4x6Domestic({
            referenceNumbers,
        });
        handlePrintLabel(fileBuffer, fileName);
    };

    const handleOnClickPrint4X6 = async (referenceNumbers: any, isInternational: boolean, fileName: string) => {
        if (isInternational) {
            await handlePrint4X6(referenceNumbers);
        } else {
            await handlePrint4X6Domestic(referenceNumbers, fileName);
        }
    };

    const handlePrintInvoice = async (referenceNumbers: any, fileName: string) => {
        setBulkPrinting(true);
        const fileBuffer = await printInvoice({
            referenceNumbers,
        });
        handlePrintLabel(fileBuffer, fileName);
    };

    const handleProofDownload = async (apiCall: string, fileName: string, selectedConsignments: any) => {
        setBulkPrinting(true);
        let response;
        switch (apiCall) {
            case 'pod':
                response = await downloadDeliveryProof({ consignments: selectedConsignments });
                break;
            case 'pop':
                response = await downloadPickupProof({ consignments: selectedConsignments });
                break;
            case 'podConfirmation':
                response = await downloadDeliveryConfirmationProof({ consignments: selectedConsignments });
                break;
            case 'popConfirmation':
                response = await downloadPickupConfirmationProof({ consignments: selectedConsignments });
                break;
            default:
                message.error('Invalid API call');
                setBulkPrinting(false);
                return;
        }
        if (response.isSuccess) {
            handlePrintLabel(response, fileName);
        } else {
            message.error('Failed to download proof');
        }
        setBulkPrinting(false);
    };

    const renderPrintInvoice = (row: any) => {
        if (
            (!row.is_international
            || !master.Customer.show_invoice_options
            || row.load_type === 'DOCUMENT') || (restrictPrintInvoice)
        ) {
            return null;
        }
        return (
            <Menu.Item
                icon={<PrinterOutlined />}
                style={{ padding: '5px 10px' }}
                onClick={() => handlePrintInvoice(
                    [row.reference_number],
                    `Invoice_${row.reference_number}.pdf`,
                )}
            >
                Print Invoice
            </Menu.Item>
        );
    };

    const renderCodeFreeLabelOptions = (row: any) => {
        return allPublishLabels.map((label: any) => (
            <Menu.Item
                style={{ padding: '5px 10px' }}
                onClick={() => handlePrint(
                    [row.reference_number],
                    getLabelType(label.label_category),
                    `Shipping_Label_${row.reference_number}.pdf`,
                )}
            >
                {label.label_category}
            </Menu.Item>
        ));
    };

    const renderCodeFreeBulkLabelOptions = () => {
        return allPublishLabels.map((label: any) => (
            <Menu.Item
                style={menuStyle}
                onClick={() => handlePrint(
                    consignmentsSelected,
                    getLabelType(label.label_category),
                    'Shipping_Label_Multiple.pdf',
                )}
            >
                {label.label_category}
            </Menu.Item>
        ));
    };

    const handleDownloadPod = async (consignment: any) => {
        setPodConsignment(consignment);
    };

    const handleSuccessOk = () => {
        setSuccessVisible(false);
    };
    const SuccessPopup = () => {
        return (
            <Modal
                visible={successVisible}
                onCancel={handleSuccessOk}
                footer={[
                    <Button key="ok" type="primary" onClick={handleSuccessOk}>
                        OK
                    </Button>,
                ]}
            >
                <div style={{ color: 'green', fontSize: '18px', fontWeight: 'bold' }}>
                    Success!
                </div>
                <div style={{ marginTop: '10px' }}>
                    Document uploaded successfully.
                </div>
            </Modal>
        );
    };

    const textString = `Maximum ${maxFiles} files can be uploaded. Formats supported are pdf, jpg, jpeg, excel.`;

    const RenderUploadModal = () => {
        return (
            <>
                <Modal
                    title="Upload Documents"
                    width={isMobile ? '100%' : '50%'}
                    visible={showUploadModal}
                    onCancel={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handlemodalclose();
                    }}
                    destroyOnClose
                    footer={[
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <InfoCircleFilled
                                style={{ color: '#006EC3', marginRight: '5px' }}
                            />
                            <div
                                style={{
                                    fontSize: '14px',
                                    opacity: '70%',
                                    color: '#232529',
                                }}
                            >
                                {textString}
                            </div>
                            <div style={{ flexGrow: 1, marginRight: '10px' }} />
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handlemodalclose();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                key="submit"
                                type="primary"
                                loading={imageUploadLoading}
                                onClick={handleUploadImageSubmit}
                            >
                                Submit
                            </Button>
                        </div>,
                    ]}
                >
                    <>
                        {documentDetails.map((doc: any, index: number) => (
                            renderDocumentTypeWiseFile(doc, index)
                        ))}
                        {documentDetails.length < maxFiles && (
                            <div
                                style={{
                                    marginTop: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                onClick={handleAddDocumentType}
                            >
                                <div className={classes.grayCircle}>
                                    {(documentDetails?.length || 0) + 1}
                                </div>
                                <PlusOutlined
                                    style={{
                                        color: '#006EC3',
                                        marginRight: '5px',
                                    }}
                                />
                                <div
                                    style={{
                                        color: '#006EC3',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                    }}
                                >
                                    Add Document Type
                                </div>
                            </div>
                        )}
                    </>
                </Modal>
            </>
        );
    };
    const handleupload = (row: any) => {
        setRowUpload(row);
        setShowUploadModal(true);
    };

    const handleMarkAsPaid = (row: any) => {
        setMarkAsPaidReferenceNumber(row.reference_number);
        setConfirmationModalVisible(true);
    };

    const markAsPaid = async () => {
        setConfirmationModalVisible(false);

        const response = await markConsignmentAsPaid({
            reference_number: markAsPaidReferenceNumber,
        });
        if (response.isSuccess) {
            message.success(`Successfully Marked Consignment No. ${markAsPaidReferenceNumber} as Paid`);
        } else {
            message.error(response.errorMessage);
        }
        setToggle(!toggle);
    };

    const renderConfirmationModal = () => {
        return (
            <Modal
                title={(
                    <div style={{ fontWeight: 600 }}>
                        <ExclamationCircleFilled style={{ color: '#EA2626', fontSize: 16 }} />
                        &nbsp;
                        {t('Confirm Action')}
                    </div>
                )}
                open={confirmationModalVisible}
                onCancel={() => setConfirmationModalVisible(false)}
                footer={[
                    <Button key="back" type="text" onClick={() => setConfirmationModalVisible(false)}>
                        {t('Cancel')}
                    </Button>,
                    <Button key="submit" type="primary" onClick={() => markAsPaid()}>
                        {t('Mark as Paid')}
                    </Button>,
                ]}
            >
                Are you sure you want to mark this consignment as paid ?
            </Modal>
        );
    };

    const handleOpenReschedule = (action: RescheduleAction, rows: RescheduleConsignment[] = []) => {
        setRescheduleVisible({
            action,
            consignments: rows,
            visible: true,
        });
    };

    const actionMenu = (row: any) => (
        <>
            {showReschedule ? (
                <Menu.Item
                    icon={<CalendarOutlined />}
                    onClick={() => handleOpenReschedule('SELECTED', [row])}
                    style={{ padding: '5px 10px' }}
                >
                    {t('reschedule')}
                </Menu.Item>
            ) : null}
            {documentConfig?.allow_document_upload ? (
                <Menu.Item
                    icon={<UploadOutlined />}
                    onClick={() => handleupload(row)}
                    style={{ padding: '5px 10px' }}
                >
                    Upload
                </Menu.Item>
            ) : null}
            {(bucketSelected === 'customer_portal_delivered' || row.status === 'delivered') ? (
                <Menu.Item
                    icon={<EyeOutlined />}
                    onClick={() => handleDownloadPod(row)}
                    style={{ padding: '5px 10px' }}
                >
                    PoD
                </Menu.Item>
            ) : null}
            {(isEditAllowed && effectiveAllowedEditStatus.includes(row.status)) ? (
                <Menu.Item
                    icon={<EditOutlined />}
                    onClick={() => {
                        setEditData(row);
                        setFormVisible(true);
                    }}
                    style={{ padding: '5px 10px' }}
                >
                    Edit
                </Menu.Item>
            ) : null}
            {(showTrackingIcon && row.tracking_url) ? (
                <Menu.Item
                    icon={<EnvironmentOutlined />}
                    style={{ padding: '5px 10px' }}
                >
                    <a href={row.tracking_url} target="_blank" rel="noreferrer">
                        Track
                    </a>
                </Menu.Item>
            ) : null}
            {(showAllowMarkAsPaid && row.is_cod && row.cod_amount && !row.upstream_payment_collected) ? (
                <Menu.Item
                    icon={<CheckCircleOutlined />}
                    style={{ padding: '5px 10px' }}
                >
                    <div onClick={() => handleMarkAsPaid(row)}>
                        Mark as Paid
                    </div>
                </Menu.Item>
            ) : null}
            {pickupProofEnabled || deliveryProofEnabled
                || deliveryConfirmationProofEnabled || pickupConfirmationProofEnabled ? (
                    <Menu.SubMenu
                        icon={<DownloadOutlined />}
                        title={t('download_proof')}
                        style={{
                            ...menuStyle,
                            padding: '6px 0px',
                            border: 'none',
                        }}
                    >
                        {pickupProofEnabled && (
                            <Menu.Item
                                style={{ padding: '5px 10px' }}
                                onClick={() => handleProofDownload('pop', 'pickup.pdf', [row.reference_number])}
                            >
                                Proof of Pickup
                            </Menu.Item>
                        )}
                        {deliveryProofEnabled && (
                            <Menu.Item
                                style={{ padding: '5px 10px' }}
                                onClick={() => handleProofDownload('pod', 'delivery.pdf', [row.reference_number])}
                            >
                                Proof of Delivery
                            </Menu.Item>
                        )}
                        {pickupConfirmationProofEnabled && (
                            <Menu.Item
                                style={{ padding: '5px 10px' }}
                                onClick={() => handleProofDownload(
                                    'popConfirmation',
                                    'pickupConfirmation.pdf',
                                    [row.reference_number],
                                )}
                            >
                                Proof of Pickup Confirmation
                            </Menu.Item>
                        )}
                        {deliveryConfirmationProofEnabled && (
                            <Menu.Item
                                style={{ padding: '5px 10px' }}
                                onClick={() => handleProofDownload(
                                    'podConfirmation',
                                    'deliveryConfirmation.pdf',
                                    [row.reference_number],
                                )}
                            >
                                Proof of Delivery Confirmation
                            </Menu.Item>
                        )}
                    </Menu.SubMenu>
                ) : null}
            {(!useThirdPartyLabel && showShippingLabelButton) ? (
                <Menu.SubMenu
                    icon={<PrinterOutlined />}
                    title={t('shipping_label')}
                    style={{
                        ...menuStyle,
                        padding: '6px 0px',
                        border: 'none',
                    }}
                >
                    {enableCodefree ? renderCodeFreeLabelOptions(row) : null}
                    {(!enableCodefree && showShipmentLabelA4) ? (
                        <Menu.Item
                            style={menuStyle}
                            onClick={() => handlePrint(
                                [row.reference_number],
                                false,
                                `Shipping_Label_${row.reference_number}.pdf`,
                            )}
                        >
                            {t('label_a4')}
                        </Menu.Item>
                    ) : null}
                    {(!enableCodefree && showShippingLabelA6) ? (
                        <Menu.Item
                            style={{ padding: '5px 10px' }}
                            onClick={() => handlePrint(
                                [row.reference_number],
                                true,
                                `Shipping_Label_${row.reference_number}.pdf`,
                            )}
                        >
                            A6
                        </Menu.Item>
                    ) : null}
                    {(!enableCodefree && showShippingLabel4X6) ? (
                        <Menu.Item
                            style={{ padding: '5px 10px' }}
                            onClick={() => handleOnClickPrint4X6(
                                [row.reference_number],
                                row.is_international,
                                `Shipping_Label_4x6_${row.reference_number}.pdf`,
                            )}
                        >
                            4*6
                        </Menu.Item>
                    ) : null}
                </Menu.SubMenu>
            ) : null}
            {!useThirdPartyLabel ? renderPrintInvoice(row) : null}
            {useThirdPartyLabel ? (
                <Menu.Item
                    icon={<PrinterOutlined />}
                    style={{ padding: '5px 10px' }}
                    onClick={() => {
                        handlePrint(
                            [row.reference_number],
                            false,
                            `Shipping_Label_${row.reference_number}.pdf`,
                        );
                    }}
                >
                    Label
                </Menu.Item>
            ) : null}
            {useThirdPartyInvoice ? (
                <Menu.Item
                    icon={<PrinterOutlined />}
                    onClick={() => {
                        handleThirdPartyInvoicePrinting(
                            row.reference_number,
                            `INVOICE_${row.reference_number}.pdf`,
                        );
                    }}
                    style={{ padding: '5px 10px' }}
                >
                    Invoice
                </Menu.Item>
            ) : null}
        </>
    );

    const renderActionsOptions = (row: any) => {
        return (
            <Dropdown overlay={() => <Menu>{actionMenu(row)}</Menu>}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '12px',
                    }}
                >
                    <MoreOutlined />
                </div>
            </Dropdown>
        );
    };

    const renderNotesDrawer = () => {
        if (!notesReferenceNumber) return null;
        return (
            <EditNotes
                referenceNumber={notesReferenceNumber}
                onClose={() => {
                    setNotesReferenceNumber(null);
                    setNotesValue(undefined);
                }}
                loadconsignments={loadconsignments}
                currentNote={notesValue}
            />
        );
    };
    const handleSupplementaryServicesConsignment = async (referenceNumber: any) => {
        if (referenceNumber) {
            const response = await fetchSupplementaryServices({
                consignment_number: referenceNumber,
                supplementary_services_to_rows: true,
                page_number: 1,
            });
            if (response?.data?.page_data && response.data.page_data.length) {
                const data = response.data.page_data;
                setIsSupplementaryServiceTable(true);
                setSupplementaryServiceData(data);
            }
        }
    };

    const renderGallery = (imageArray: any[], videoArray: any[]) => {
        if (!imageArray || !videoArray) return 'Not Available';
        if (!imageArray.length && !videoArray.length) return 'Not Available';
        return (
            <a onClick={() => {
                setGalleryModalData({
                    images: imageArray,
                    videos: videoArray,
                });
                setIsGalleryModalVisible(true);
            }}
            >
                View
            </a>
        );
    };
    const combineMultipleImagesVideo = (imageListId: string[], videoListId: string[], data: { [x: string]: any; }) => {
        const cnImages: any[] = [];
        const cnVideos: any[] = [];
        imageListId.forEach((imageId) => {
            if (Array.isArray(data[imageId]) && data[imageId].length) {
                data[imageId].forEach((image: any) => {
                    if (image) {
                        cnImages.push(image);
                    }
                });
            } else if (data[imageId] && !Array.isArray(data[imageId])) {
                cnImages.push(data[imageId]);
            }
        });
        videoListId.forEach((videoId) => {
            if (Array.isArray(data[videoId]) && data[videoId].length) {
                data[videoId].forEach((video: any) => {
                    if (video) {
                        cnVideos.push(video);
                    }
                });
            } else if (data[videoId] && !Array.isArray(data[videoId])) {
                cnVideos.push(data[videoId]);
            }
        });
        return renderGallery(cnImages, cnVideos);
    };

    const renderTextModal = (data: string) => {
        if (!data) return 'Not Available';
        return (
            <a onClick={() => {
                setTextModalData({ text: data, title: 'Customer Feedback' });
                setIsTextModalVisible(true);
            }}
            >
                View
            </a>
        );
    };

    const formatDimension = (length: string, width: string, height: string) => {
        if (length && width && height) {
            return `${length}*${width}*${height}`;
        }
        return '';
    };

    const renderAmountCollectedDetails = (data: any) => {
        const columns = [
            {
                title: 'S.No.',
                key: 'sno',
                width: '20px',
                render: (text: any, object: any, index: any) => (index + 1),
            },
            {
                title: 'Amount',
                dataIndex: 'cod_amount',
                key: 'cod_amount',
            },
            {
                title: 'Collection Mode',
                dataIndex: 'cod_collection_mode',
                key: 'cod_collection_mode',
                width: '150px',
            },
            {
                title: 'Favor of',
                dataIndex: 'cod_favor_of',
                key: 'cod_favor_of',
                width: '100px',
            },
        ];
        return (
            <Table
                dataSource={data}
                columns={columns}
                pagination={false}
                style={{
                    margin: '0 10px',
                }}
            />
        );
    };
    const renderLinkModal = (row: any) => {
        return (
            <DocumentDetailsModal
                isVisible={isVisible}
                onModalClose={() => setIsVisible(false)}
                documentDetails={row?.document_details}
            />
        );
    };

    const renderCustomFields = (text: any, column: ConsignmentColumn) => {
        const { complete_custom_fields_list } = config;
        const customField = complete_custom_fields_list.find((field: any) => field.id === column.column_id);
        let dataType = customField?.formUIComponent?.type;
        if (!(dataType && dataType === 'dropdown')) {
            dataType = customField?.dataType;
        }
        switch (dataType) {
            case 'string':
            case 'number':
            case 'boolean':
            case 'dropdown':
                return text;
            case 'date': return formatDateTime(text, 'date');
            case 'datetime': return formatDateTime(text, 'datetime');
            default: return 'Input is not defined';
        }
    };

    const renderColumn = (text: any, row: any, column: ConsignmentColumn) => {
        const { complete_custom_fields_list } = config;
        if (column.column_id === 'reference_number') {
            return renderText(text, row);
        }
        if (dateColumnKeys.includes(column.column_id) && text) {
            const dateString = moment(text).format('DD MMM, YYYY');
            return dateString;
        }
        if (column.column_id === 'document_details') {
            return row?.document_details ? (
                <div>
                    <Button
                        type="link"
                        onClick={() => {
                            setModalRow(row);
                            setIsVisible(true);
                        }}
                    >
                        View
                    </Button>
                </div>
            ) : (
                'Not Available'
            );
        }
        if (dateKeysPickup.includes(column.column_id) && text) {
            const dateString = moment(text).format('DD-MM-YYYY hh:mm A');
            return dateString;
        }
        if (dateKeysWithStringTimestamp.includes(column.column_id) && text) {
            const dateString = moment(Number(text)).format('DD MMM YYYY, HH:mm A');
            return dateString;
        }
        if (column.column_id === 'status') {
            return <StatusPrettyName status={text} useMariaDb={useMariaDb} />;
        }
        if (column.column_id === 'is_international') {
            return text ? 'True' : 'False';
        }
        if (column.column_id === 'movement_type') {
            return prettyMovementTypes[text] || text;
        }
        if (column.column_id === 'estimated_delivery_time') {
            const textToRender = text
                ? moment(text).format('DD MMM YYYY | hh:mm A')
                : 'Not Available';
            return textToRender;
        }
        if (column.column_id === 'expected_delivery_date' && text) {
            const dateString = moment(text).format('DD MMM, YYYY');
            return dateString;
        }
        if (column.column_id === 'actions') {
            return renderActionsOptions(row);
        }
        if (column.column_id === 'customer_pod') {
            if (!row[column.column_id] || !row[column.column_id].length) {
                return <div className={classes.cellNa}>-NA-</div>;
            }
            return renderGallery(row[column.column_id], []);
        }
        if (column.column_id === 'supplementary_services_added') {
            const supplementaryServices = row[column.column_id];
            let dataToRender = 'No';
            if (supplementaryServices && Array.isArray(supplementaryServices) && supplementaryServices.length) {
                let sumOfServices = 0;
                let invalidStatusRequest = 0;
                supplementaryServices.forEach((service) => {
                    if (service.supplementary_service_list_count
                        && !Number.isNaN(service.supplementary_service_list_count)) {
                        sumOfServices += service.supplementary_service_list_count;
                    }
                    if (service.status && ['REJECTED', 'CANCELLED'].includes(service.status)) {
                        invalidStatusRequest += 1;
                    }
                });
                if ((invalidStatusRequest !== supplementaryServices.length)
                    && !Number.isNaN(sumOfServices)
                    && Number(sumOfServices) > 0) {
                    dataToRender = 'Yes';
                }
            }
            return (
                <span>
                    {dataToRender}
                    {supplementaryServices && supplementaryServices.length ? (
                        <Tooltip title="">
                            <a>
                                <InfoCircleOutlined
                                    style={{ marginLeft: 5 }}
                                    onClick={() => handleSupplementaryServicesConsignment(row?.reference_number || '')}
                                />
                            </a>
                        </Tooltip>
                    ) : null}
                </span>
            );
        }
        if (['signature_image', 'pod_image_url', 'poc_image', 'latest_pickup_proof_of_pickup_image',
            'card_transaction_image'].includes(column.column_id)) {
            if (!row[column.column_id]) {
                return <div className={classes.cellNa}>-NA-</div>;
            }
            return renderGallery([row[column.column_id]], []);
        }
        if (column.column_id === 'customer_feedback') {
            return renderTextModal(row[column.column_id]);
        }
        if (column.column_id === 'dimension') {
            return formatDimension(row?.length, row?.width, row?.height);
        }
        if (column.column_id === 'given_dimension') {
            return formatDimension(row?.given_length, row?.given_width, row?.given_height);
        }
        if (column.column_id === 'customer_reference_number_2') {
            return row.customer_reference_number;
        }
        if (column.column_id === 'customer_code_2') {
            return row.customer_code;
        }
        if (column.column_id === 'customer_name_2') {
            return row.customer_name;
        }
        if (column.column_id === 'parent_customer_code_2') {
            return row.parent_customer_code;
        }
        if (column.column_id === 'parent_customer_name_2') {
            return row.parent_customer_name;
        }
        if (column.column_id === 'poc_image') {
            if (text) return (<Button onClick={() => setImageUrl(text)} type="link">View</Button>);
            return (<div className={classes.cellNa}>-NA-</div>);
        }
        if (column.column_id === 'notes') {
            return (
                <div
                    className={classes.notesCellValue}
                >
                    <EditOutlined
                        style={{ marginRight: 5 }}
                        onClick={() => {
                            setNotesReferenceNumber(row.reference_number);
                            setNotesValue(text);
                        }}
                    />
                    <Tooltip
                        className={classes.cellValue}
                        title={text}
                        overlayStyle={{
                            fontSize: 12,
                            margin: 0,
                            padding: 0,
                            letterSpacing: 0,
                            whiteSpace: 'pre-line',
                        }}
                    >
                        <span
                            style={{ width: 90, overflow: 'hidden', marginRight: 10 }}
                            onClick={() => {
                                setDetails(row?.reference_number);
                                history.push(getConginmentDetailsUrl(row?.reference_number));
                            }}
                        >
                            {text}
                        </span>
                    </Tooltip>
                </div>
            );
        }
        if (column.column_id === 'cod_amount_collected') {
            if (Helper.isValidArray(text)) {
                return (
                    <Popover
                        trigger="click"
                        title="Amount collected details"
                        content={() => renderAmountCollectedDetails(text)}
                    >
                        <Button type="link">Show</Button>
                    </Popover>
                );
            }
            return <div className={classes.cellNa}>-NA-</div>;
        }
        if (column.column_id === 'delivery_timeslots') {
            if (isEmpty(text)) {
                return <div className={classes.cellNa}>-NA-</div>;
            }
            return (
                <div className={classes.cellValue}>
                    {text?.start || ''}
                    {' - '}
                    {text?.end || ''}
                </div>
            );
        }
        if (['poc_image_video_list', 'pop_image_video_list'].includes(column.column_id)) {
            const imageIdList = column.image_list || [];
            const videoIdList = column.video_list || [];
            return combineMultipleImagesVideo(imageIdList, videoIdList, row);
        }
        if (column.column_id === 'final_price') {
            return (
                <div className={classes.finalPrice}>
                    {currencySymbol}
                    {' '}
                    {text}
                </div>
            );
        }
        if (column.column_id === 'delivery_completion_time' && text) {
            const dateString = formatDateTime(text, 'datetime', 'DD MMM YYYY, HH:mm A');
            return dateString;
        }
        if (!text || text === null) {
            return <div className={classes.cellNa}>-NA-</div>;
        }
        if (complete_custom_fields_list && complete_custom_fields_list.find((field) => field.id === column.column_id)) {
            return renderCustomFields(text, column);
        }
        // please don't change this default object check
        if (typeof text === 'object') {
            return <div className={classes.cellValue}>{JSON.stringify(text)}</div>;
        }
        return text;
    };

    const getWidth = (id: string) => {
        switch (id) {
            case 'actions': return (config?.allow_multiple_file_upload_in_customer_portal ? 80 : 60);
            case 'status':
            case 'reference_number':
            case 'destination_name':
            case 'courier_partner_reference_number':
            case 'customer_reference_number': return 150;
            case 'movement_type':
            default: return 120;
        }
    };

    const getColumns = (): any[] => {
        const { consignment_column_list } = config || {};

        const actionColumn = {
            column_id: 'actions',
            is_sortable: false,
            pretty_name: t('actions'),
        };

        let columnLables = [];

        if (consignmentPageData) {
            const viewData = consignmentPageData.metadata.sectionList.flat().find((v) => v.id === bucketSelected);
            columnLables = (viewData?.visibleFieldList || viewData?.metadata?.fieldList)?.filter(
                (item) => item.showUi,
            )?.map((field) => ({
                column_id: field.id,
                is_sortable: false,
                pretty_name: field.name,
            })) || [];
        } else if (consignment_column_list && consignment_column_list[bucketSelected as ConsignmentBucketKeys]?.length) {
            columnLables.push(...consignment_column_list[bucketSelected as ConsignmentBucketKeys]);
        } else {
            columnLables.push(...defaultConsignmentColumns);
        }

        if (useMariaDb && allowedColumns?.length) {
            columnLables = columnLables.filter((column: ConsignmentColumn) => {
                return allowedColumns.includes(column.column_id);
            });
        }

        columnLables.push(actionColumn);

        const columns: any = columnLables.map((column: ConsignmentColumn) => {
            return {
                key: column.column_id,
                title: consignmentPageData || !i18n.exists(column.column_id) ? column.pretty_name : t(column.column_id),
                dataIndex: column.column_id,
                width: getWidth(column.column_id),
                justifyContent: column.column_id === 'actions',
                ellipsis: column.column_id !== 'actions',
                fixed: column.column_id === 'actions' ? 'right' : undefined,
                render: (text: string, row: any) => renderColumn(text, row, column),
                isSortable: dateKeys.includes(column.column_id),
            };
        });
        return columns;
    };

    const handleColumnSort = (type: string, column: any) => {
        const newFilters = {
            ...filters,
            sortBy: column.key,
            descendingOrder: type === 'desc',
        };
        setfilters(Buckets.CONSIGNMENTS, newFilters);
        applyfilters(Buckets.CONSIGNMENTS);
    };

    const handlePageChange = (page: PageKeys) => {
        if (page === pageSelected) {
            return;
        }
        let nextPage = getConsignmentsRoute();
        switch (page) {
            case 'PluginOrders': nextPage = getPluginOrdersRoute(); break;
            case 'ExcelUpload': nextPage = getExcelUploadRoute(); break;
            case 'PrintHistory': nextPage = getPrintHistoryRoute(); break;
            case 'Consignments':
            default: nextPage = getConsignmentsRoute(); break;
        }
        setPageSelected(page);
        history.push(nextPage);
    };

    const getTabName = (bucket: string, bucketData: { name: string, width: number }) => {
        let countClass = classes.count;
        if (bucket === bucketSelected) {
            countClass = [classes.count, classes.countSelected].join(' ');
        }

        return (
            <>
                <span style={{ color: bucket === bucketSelected ? '#111' : '#666' }}>
                    {!consignmentPageData ? t(bucket) : bucketData.name}
                </span>
                {
                    !consignmentPageData && showBucketCount
                        ? (<span className={countClass}>{summary[bucket] || 0}</span>)
                        : null
                }
            </>
        );
    };

    const renderBucket = (bucket: string, bucketData: { name: string, width: number }) => {
        return (
            <Tabs.TabPane
                tab={getTabName(bucket, bucketData)}
                key={bucket}
            />
        );
    };

    const renderBuckets = () => {
        let allowedBuckets: any = ConsignmentBuckets;

        if (consignmentPageData) {
            allowedBuckets = consignmentPageData.metadata.sectionList?.flat()?.reduce((acc: any, view) => {
                if (!acc[view.id]) {
                    acc[view.id] = {
                        name: view.name,
                        width: 10,
                    };
                }
                return acc;
            }, {}) || {};
        }
        return (
            <div className={classes.tabsContainer}>
                <Tabs
                    className={classes.bucketRow}
                    activeKey={bucketSelected}
                    onChange={(bucket) => handleBucketChange(bucket)}
                >
                    {Object.keys(allowedBuckets).map((bucket) => renderBucket(bucket, allowedBuckets[bucket]))}
                </Tabs>
            </div>
        );
    };

    const renderDateType = (() => {
        let allowedDateKeys = dateKeys;
        if (useMariaDb) {
            allowedDateKeys = ['created_at'];
        }
        return (
            <Select
                className={classes.dateTypeSelect}
                onChange={(value) => {
                    const newFilters = {
                        ...filters,
                    };
                    newFilters.dateType = value;
                    setfilters(Buckets.CONSIGNMENTS, newFilters);
                    applyfilters(Buckets.CONSIGNMENTS);
                    setDateType(value);
                }}
                value={dateType}
                dropdownMatchSelectWidth={false}
            >
                {allowedDateKeys.map((item) => {
                    return (
                        <Select.Option
                            key={item}
                            value={item}
                        >
                            {t(item)}
                        </Select.Option>
                    );
                })}
            </Select>
        );
    });

    const disabledDate = (current: any) => {
        return current && current > moment().endOf('day');
    };

    const handleDateChange = (value: any) => {
        if (!(value && value[0] && value[1])) return;
        const newFilters = {
            ...filters,
        };
        if (value[1].isSame(filters.endDate)) {
            if (moment(filters.endDate).diff(value[0], 'days') > 30) {
                const endDate = moment(value[0]).add(30, 'd');
                newFilters.endDate = endDate.unix() * 1000;
                newFilters.startDate = moment(value[0]).unix() * 1000;
            } else {
                newFilters.endDate = moment(value[1]).unix() * 1000;
                newFilters.startDate = moment(value[0]).unix() * 1000;
            }
        } else if (moment(value[1]).diff(value[0], 'days') > 30) {
            const startDate = moment(value[1]).subtract(30, 'd');
            newFilters.startDate = startDate.unix() * 1000;
            newFilters.endDate = moment(value[1]).unix() * 1000;
        } else {
            newFilters.endDate = moment(value[1]).unix() * 1000;
            newFilters.startDate = moment(value[0]).unix() * 1000;
        }
        setfilters(Buckets.CONSIGNMENTS, newFilters);
        applyfilters(Buckets.CONSIGNMENTS);
    };

    const renderRangePicker = () => {
        return (
            <div className={classes.filter}>
                <DatePicker.RangePicker
                    value={[moment(filters.startDate), moment(filters.endDate)]}
                    allowClear={false}
                    allowEmpty={[false, false]}
                    disabledDate={disabledDate}
                    dropdownClassName={classes.dateRange}
                    placeholder={['Select Start Date', 'Select End Date']}
                    onChange={(value) => handleDateChange(value)}
                />
            </div>
        );
    };


    const isMoreFilterAdded = (excludeStatus = false) => {
        const isFilterApplied = Object.keys(filters).some((filter) => {
            if (['endDate', 'startDate'].includes(filter)) {
                return false;
            }
            if (excludeStatus && ['statusList'].includes(filter)) {
                return false;
            }
            return filters[filter] !== defaultFilters[filter];
        });
        return isFilterApplied;
    };

    const renderMoreFiltersOption = () => {
        const filterApplied = isMoreFilterAdded();
        return (
            <Button
                onClick={() => setMoreFiltersVisible(true)}
                style={{
                    color: filterApplied ? '#006ec3' : '#111111',
                    fontWeight: 500,
                    fontSize: 12,
                    borderColor: 'white',
                    padding: '5px 0px',
                    boxShadow: 'none',
                }}
                icon={<FilterOutlined />}
            >
                <span>{t('more_filters')}</span>
            </Button>
        );
    };

    const handleResetFilters = () => {
        setInputFilterVal('');
        setDateType(dateKeys[0]);
        setfilters(Buckets.CONSIGNMENTS, {
            ...defaultFilters,
            bucketSelected: consignmentPageData ? bucketSelected : defaultFilters.bucketSelected,
            fromDate: filters.fromDate,
            toDate: filters.toDate,
        });
        applyfilters(Buckets.CONSIGNMENTS);
    };

    const renderResetFiltersOption = () => {
        const filterApplied = isMoreFilterAdded();
        if (!filterApplied) {
            return null;
        }
        return (
            <div
                className={classes.resetFilter}
                onClick={() => handleResetFilters()}
            >
                {t('reset_filters')}
            </div>
        );
    };

    const renderDateFilter = () => {
        return (
            <div className={classes.dateFilter}>
                {renderDateType()}
                {renderRangePicker()}
            </div>
        );
    };

    const onChangeFilter = (filter: string, value: any) => {
        const newFilters = {
            ...filters,
            [filter]: value || undefined,
        };
        setfilters(Buckets.CONSIGNMENTS, newFilters);
        applyfilters(Buckets.CONSIGNMENTS);
    };

    const handleDashboardRangeSelect = (filterId: string, dates: any) => {
        if (dates && dates[0] && dates[1]) {
            onChangeFilter(filterId, {
                startDate: dates[0],
                endDate: dates[1],
            });
        } else {
            onChangeFilter(filterId, undefined);
        }
    };

    const getDashboardFilterOptions = (filterMeta: FilterMetadata) => {
        if (filterMeta.search_strategy === 'customer_code_search') {
            const childList = master?.children_list || [];
            return childList.map((child: any) => ({
                label: `${child.customer_code} (${child.customer_name})`,
                value: child.customer_id,
            }));
        }
        if (!Array.isArray(filterMeta.options) || !filterMeta.options.length) {
            return undefined;
        }
        const mappedOptions = filterMeta.options.map((item: any) => {
            const option = {
                ...item,
            };
            if (filterMeta.id === 'statusList') {
                option.label = <StatusPrettyName status={option.value} />;
            } else if (filterMeta.id === 'isInternational' || filterMeta.id === 'isCod') {
                option.label = t(option.label);
            } else if (typeof option.value === 'string' && i18n.exists(option.value)) {
                option.label = t(option.value);
            }
            return option;
        });
        if (filterMeta.id === 'courierPartnerList') {
            return [...mappedOptions, { label: 'SELF', value: 'SELF' }];
        }
        return mappedOptions;
    };

    const renderDashboardFilter = (filterMeta: FilterMetadata) => {
        if (!filterMeta) {
            return null;
        }
        const placeholder = filterMeta.placeholder || t(`${filterMeta.id}_placeholder`);
        const rangePlaceholders = filterMeta.placeholder
            ? filterMeta.placeholder.split('|').map((text) => text.trim())
            : [];
        const startPlaceholder = rangePlaceholders[0] || filterMeta.label || t('start_date');
        const endPlaceholder = rangePlaceholders[1] || filterMeta.label || t('end_date');
        const filterValue = filters[filterMeta.id];

        if (filterMeta.type === FilterType.rangeDate || filterMeta.type === FilterType.rangeDateTime) {
            const value: [Moment, Moment] | undefined = filterValue && filterValue.startDate && filterValue.endDate
                ? [
                    moment(filterValue.startDate),
                    moment(filterValue.endDate),
                ]
                : undefined;
            return (
                <DatePicker.RangePicker
                    key={filterMeta.id}
                    className={classes.selectFilterWide}
                    value={value}
                    placeholder={[startPlaceholder, endPlaceholder]}
                    format={filterMeta.type === FilterType.rangeDateTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'}
                    showTime={filterMeta.type === FilterType.rangeDateTime ? { format: 'HH:mm' } : undefined}
                    onChange={(dates) => handleDashboardRangeSelect(filterMeta.id, dates)}
                />
            );
        }

        if (filterMeta.type === FilterType.select || filterMeta.type === FilterType.selectSearch) {
            const options = getDashboardFilterOptions(filterMeta);
            const selectValue = Array.isArray(filterValue) ? filterValue[0] : filterValue;
            return (
                <Select
                    key={filterMeta.id}
                    className={classes.selectFilter}
                    value={selectValue}
                    allowClear
                    placeholder={placeholder}
                    dropdownMatchSelectWidth={false}
                    showSearch={filterMeta.type === FilterType.selectSearch}
                    filterOption={
                        filterMeta.type === FilterType.selectSearch
                            ? (input, option) => (option?.label as string || '').toLowerCase().includes(input.toLowerCase())
                            : undefined
                    }
                    options={options}
                    onChange={(value) => onChangeFilter(filterMeta.id, value)}
                />
            );
        }

        if (filterMeta.type === FilterType.input) {
            return (
                <Input
                    key={filterMeta.id}
                    className={classes.selectFilter}
                    value={filterValue}
                    placeholder={placeholder}
                    onChange={(e) => onChangeFilter(filterMeta.id, e.target.value)}
                />
            );
        }

        if (filterMeta.type === FilterType.search) {
            const options = getDashboardFilterOptions(filterMeta) || [];
            const selectValue = Array.isArray(filterValue) ? filterValue[0] : filterValue;
            return (
                <Select
                    key={filterMeta.id}
                    className={classes.selectFilter}
                    value={selectValue}
                    allowClear
                    showSearch
                    placeholder={placeholder}
                    options={options}
                    optionFilterProp="label"
                    dropdownMatchSelectWidth={false}
                    onChange={(value) => onChangeFilter(filterMeta.id, value)}
                />
            );
        }

        return null;
    };

    const renderLeftFilters = () => {
        const dashboardFilters = dashboardFilterMetadata.map((filterMeta) => renderDashboardFilter(filterMeta));
        return (
            <div className={classes.leftFilters}>
                {dashboardFilters}
                {renderMoreFiltersOption()}
                {renderResetFiltersOption()}
            </div>
        );
    };

    const handleDownload = async () => {
        const dateFormat = 'YYYY-MM-DD';
        setDownloading(true);
        const moreFilters = getMoreFilters(filters);

        const bucketKey = consignmentPageData ? 'customer_portal_all' : filters.bucketSelected;
        const filtersInfo = getFilters(bucketKey, config);
        filtersInfo.forEach((filter: any) => {
            if (moreFilters[filter.id] && filter.mode === 'multiple' && typeof moreFilters[filter.id] === 'string') {
                moreFilters[filter.id] = moreFilters[filter.id].split(',').map((value: string) => value.trim());
            }
        });

        const deliverySlotValue = moreFilters.delivery_time_slot || moreFilters.deliveryTimeslot;
        const filteredMoreFilters = { ...moreFilters };
        delete filteredMoreFilters.delivery_time_slot;
        delete filteredMoreFilters.deliveryTimeslot;

        const baseTimeFilters = [
            {
                columnName: filters.dateType || filters.sortBy,
                fromDateString: moment(filters.startDate).format(dateFormat),
                toDateString: moment(filters.endDate).format(dateFormat),
            },
        ];
        const deliverySlotTimeFilter = buildDeliverySlotTimeFilter(deliverySlotValue);
        const finalizedTimeFilters = deliverySlotTimeFilter
            ? [...baseTimeFilters, deliverySlotTimeFilter]
            : baseTimeFilters;

        const response = await downloadConsignments({
            customerIdList: [],
            bucket: filters.bucketSelected,
            timeFilters: finalizedTimeFilters,
            descendingOrder: filters.descendingOrder,
            referenceNumberList: consignmentsSelected,
            ...filteredMoreFilters,
        });
        if (response.isSuccess) {
            message.success('Requested Successfully');
            history.push(getDownloadsRoute());
        } else {
            message.error(response.errorMessage);
        }
        setDownloading(false);
    };

    const renderDownload = () => {
        return (
            <Menu.Item
                style={{ ...menuItemBaseStyle }}
                key="downloadMenu"
                disabled={downloading}
                onClick={handleDownload}
            >
                {t('download')}
            </Menu.Item>
        );
    };

    const renderProofDownload = () => {
        if (!pickupProofEnabled && !deliveryProofEnabled
            && !deliveryConfirmationProofEnabled && !pickupConfirmationProofEnabled) {
            return null;
        }
        return (
            <Menu.SubMenu
                title={(
                    <span style={{
                        ...ActionMenuStyle,
                        padding: 0,
                        border: 'none',
                    }}
                    >
                        {t('download_proof')}
                    </span>
                )}
                style={{
                    padding: 0,
                    border: 'none',
                }}
                key="DownloadProofSubmenu"
            >
                {pickupProofEnabled && (
                    <Menu.Item
                        key="PICKUP_PROOF"
                        style={ActionMenuStyle}
                        onClick={() => handleProofDownload('pop', 'pickup.pdf', consignmentsSelected)}
                    >
                        Proof of Pickup
                    </Menu.Item>
                )}
                {deliveryProofEnabled && (
                    <Menu.Item
                        key="DELIVERY_PROOF"
                        style={ActionMenuStyle}
                        onClick={() => handleProofDownload('pod', 'delivery.pdf', consignmentsSelected)}
                    >
                        Proof of Delivery
                    </Menu.Item>
                )}
                {pickupConfirmationProofEnabled && (
                    <Menu.Item
                        key="PICKUP_CONFIRMATION_PROOF"
                        style={ActionMenuStyle}
                        onClick={() => handleProofDownload(
                            'popConfirmation',
                            'pickupConfirmation.pdf',
                            consignmentsSelected,
                        )}
                    >
                        Proof of Pickup Confirmation
                    </Menu.Item>
                )}
                {deliveryConfirmationProofEnabled && (
                    <Menu.Item
                        key="DELIVERY_CONFIRMATION_PROOF"
                        style={ActionMenuStyle}
                        onClick={() => handleProofDownload(
                            'podConfirmation',
                            'deliveryConfirmation.pdf',
                            consignmentsSelected,
                        )}
                    >
                        Proof of Delivery Confirmation
                    </Menu.Item>
                )}
            </Menu.SubMenu>
        );
    };

    const renderPrintInvoiceBulk = (rows: any) => {
        if (!master.Customer.show_invoice_options || restrictPrintInvoice) {
            return null;
        }

        return (
            <Menu.Item
                style={menuStyle}
                onClick={() => handlePrintInvoice(
                    rows,
                    'Invoice_Multiple.pdf',
                )}
            >
                Print Invoice
            </Menu.Item>
        );
    };

    const handleOpenCancellation = (action: string) => {
        setCancelVisible({
            action,
            visible: true,
        });
    };

    // Selected CNs may span pages, so fall back to the reference number when the row isn't loaded
    const getSelectedRescheduleRows = (): RescheduleConsignment[] => {
        return consignmentsSelected.map((referenceNumber) => {
            const row = (consignments || []).find((item: any) => item.reference_number === referenceNumber);
            return {
                reference_number: referenceNumber,
                expected_delivery_date: row?.expected_delivery_date,
            };
        });
    };

    const renderReschedule = () => {
        return (
            <Menu.SubMenu
                title={(
                    <span style={{
                        fontWeight: 600,
                        borderRadius: 4,
                    }}
                    >
                        {t('reschedule')}
                    </span>
                )}
                key="RescheduleSubmenu"
            >
                <Menu.Item
                    style={{
                        ...menuItemBaseStyle,
                        marginTop: 12,
                        marginLeft: 12,
                        marginRight: 12,
                    }}
                    key="RESCHEDULE_SELECTED"
                    disabled={!consignmentsSelected.length}
                    onClick={() => handleOpenReschedule('SELECTED', getSelectedRescheduleRows())}
                >
                    {t('reschedule_selected')}
                </Menu.Item>
                <Menu.Item
                    style={{
                        ...menuItemBaseStyle,
                        marginBottom: 12,
                        marginLeft: 12,
                        marginRight: 12,
                    }}
                    key="RESCHEDULE_BULK"
                    onClick={() => handleOpenReschedule('BULK')}
                >
                    {t('reschedule_bulk_upload')}
                </Menu.Item>
            </Menu.SubMenu>
        );
    };

    const renderSchedulePickup = () => {
        if (!showPickupScheduleButton) return null;
        return (
            <Menu.Item
                style={{ ...menuItemBaseStyle }}
                key="schedulePickupMenu"
                onClick={() => setScheduleVisible(true)}
            >
                Schedule Pickup
            </Menu.Item>
        );
    };

    const renderCancel = () => {
        return (
            <Menu.SubMenu
                title={(
                    <span style={{
                        fontWeight: 600,
                        borderRadius: 4,
                    }}
                    >
                        {t('cancel')}
                    </span>
                )}
                key="CancelSubmenu"
            >
                <Menu.Item
                    style={{
                        ...menuItemBaseStyle,
                        marginTop: 12,
                        marginLeft: 12,
                        marginRight: 12,
                    }}
                    key="BULK"
                    onClick={() => handleOpenCancellation('BULK')}
                >
                    {t('upload_excel_bulk_update')}
                </Menu.Item>
                {showCancelButton && (
                    <Menu.Item
                        style={{
                            ...menuItemBaseStyle,
                            marginLeft: 12,
                            marginRight: 12,
                        }}
                        key="CANCEL"
                        onClick={() => handleOpenCancellation('CANCEL')}
                    >
                        {t('mark_cancelled')}
                    </Menu.Item>
                )}
                <Menu.Item
                    style={{
                        ...menuItemBaseStyle,
                        marginBottom: 12,
                        marginLeft: 12,
                        marginRight: 12,
                    }}
                    key="REVOKE"
                    onClick={() => handleOpenCancellation('REVOKE')}
                >
                    {t('mark_released')}
                </Menu.Item>
            </Menu.SubMenu>
        );
    };

    const handleThirdPartyBulkPrinting = async () => {
        setBulkPrinting(true);
        let response;
        if (softdataCreationUnifiedFlow) {
            const payload = {
                label_type: 'THIRD_PARTY_CONSIGNMENT_LABEL',
                reference_number_array: consignmentsSelected,
                action_type: 'useParams',
            };
            response = await printBulkLabelWithPx(payload);
        } else {
            const payload = {
                labelType: 'THIRD_PARTY_CONSIGNMENT_LABEL',
                consignmentList: consignmentsSelected,
            };
            response = await printBulkLabel(payload);
        }
        setBulkPrinting(false);
        if (response.isSuccess) {
            message.success('Print Request Added');
            handlePageChange('PrintHistory');
        } else {
            message.error(response.errorMessage);
        }
    };

    const handleThirdPartyBulkInvoicePrinting = async () => {
        setBulkPrinting(true);
        const payload = {
            type: 'THIRD_PARTY_CONSIGNMENT_INVOICE',
            referenceNumbers: consignmentsSelected,
        };
        const response = await printBulkConsignmentInvoice(payload);
        setBulkPrinting(false);
        if (response.isSuccess) {
            message.success('Print Invoice Request Added');
            handlePageChange('PrintHistory');
        } else {
            message.error(response.errorMessage);
        }
    };

    const renderBulkPrintOptions = () => {
        return (
            <Menu>
                {showShippingLabelButton && (
                    <Menu.SubMenu
                        title={(
                            <span
                                style={{
                                    ...menuStyle,
                                    padding: 0,
                                    border: 'none',
                                }}
                            >
                                {t('shipping_label')}
                            </span>
                        )}
                        style={{
                            ...menuStyle,
                            padding: '6px 0px',
                            border: 'none',
                        }}
                    >
                        {enableCodefree ? renderCodeFreeBulkLabelOptions() : (
                            <>
                                {showShipmentLabelA4 && (
                                    <Menu.Item
                                        style={menuStyle}
                                        onClick={() => handlePrint(consignmentsSelected, true,
                                            'Shipping_Label_Multiple.pdf')}
                                    >
                                        {t('label_a4')}
                                    </Menu.Item>
                                )}
                                {showShippingLabelA6 && (
                                    <Menu.Item
                                        style={menuStyle}
                                        onClick={() => handlePrint(consignmentsSelected, false,
                                            'Shipping_LabelMultiple.pdf')}
                                    >
                                        {t('label_a6')}
                                    </Menu.Item>
                                )}
                                {showShippingLabel4X6 && (
                                    <Menu.Item
                                        style={menuStyle}
                                        onClick={() => handlePrint4X6(consignmentsSelected)}
                                    >
                                        4*6 International
                                    </Menu.Item>
                                )}
                                {showShippingLabel4X6 && (
                                    <Menu.Item
                                        style={menuStyle}
                                        onClick={() => handlePrint4X6Domestic(
                                            consignmentsSelected,
                                            'Shipping_Label_4x6_Multiple.pdf',
                                        )}
                                    >
                                        4*6 Domestic
                                    </Menu.Item>
                                )}
                            </>
                        )}
                    </Menu.SubMenu>
                )}
                {renderPrintInvoiceBulk(consignmentsSelected)}
            </Menu>
        );
    };

    const BulkPrintModal = () => {
        return (
            <BulkPrint
                isVisible={showBulkPrintModal}
                onClose={() => setShowBulkPrintModal(false)}
                onSuccess={() => {
                    setShowBulkPrintModal(false);
                    handlePageChange('PrintHistory');
                }}
                consignments={consignmentsSelected}
            />
        );
    };

    const renderBulkPrint = () => {
        return useBulkPrintModal ? (
            <Button
                type="primary"
                className={classes.downloadBtn}
                loading={bulkPrinting}
                onClick={() => setShowBulkPrintModal(true)}
            >
                {t('bulk_download')}
            </Button>
        ) : (
            <Dropdown
                overlay={renderBulkPrintOptions()}
            >
                <Button
                    type="primary"
                    className={classes.downloadBtn}
                    loading={bulkPrinting}
                >
                    {t('bulk_download')}
                </Button>
            </Dropdown>
        );
    };

    const menu = () => (
        <Menu>
            {useThirdPartyLabel && (
                <Menu.Item
                    onClick={handleThirdPartyBulkPrinting}
                    style={{ padding: '5px 10px' }}
                >
                    Label
                </Menu.Item>
            )}
            {useThirdPartyInvoice && (
                <Menu.Item
                    onClick={handleThirdPartyBulkInvoicePrinting}
                    style={{ padding: '5px 10px' }}
                >
                    Invoice
                </Menu.Item>
            )}
        </Menu>
    );

    const renderPrint = () => {
        if (consignmentsSelected.length < 2) {
            return (
                <Button
                    type="primary"
                    className={classes.downloadBtn}
                    loading={bulkPrinting}
                    disabled
                    icon={<DownloadOutlined />}
                >
                    {t('download')}
                </Button>
            );
        }
        if (useThirdPartyLabel || useThirdPartyInvoice) {
            return (
                <Dropdown overlay={menu}>
                    <Button
                        type="primary"
                        className={classes.downloadBtn}
                        loading={bulkPrinting}
                        icon={<DownloadOutlined />}
                    >
                        {t('bulk_download')}
                    </Button>
                </Dropdown>
            );
        }
        return renderBulkPrint();
    };

    const handleSettingsClose = (refresh?: boolean) => {
        setSettingsVisible(false);
        if (refresh) {
            setToggle(!toggle);
            if (consignmentPageData) {
                fetchConsignmentData(bucketSelected);
            }
        }
    };
    const renderSettingsModal = () => {
        if (!settingsVisible) {
            return null;
        }
        const filterObject: Record<string, FilterMetadata> = {};
        config?.filter_metadata?.forEach((item) => {
            filterObject[item.id] = item;
        });

        let columnData = config?.full_column_list || [];

        if (consignmentPageData) {
            const viewData = consignmentPageData.metadata.sectionList.flat().find((v) => v.id === bucketSelected);
            columnData = viewData?.metadata?.fieldList?.map((field) => ({
                column_id: field.id,
                pretty_name: field.name,
                is_sortable: false,
            })) || [];
        }

        const options = uniqBy(columnData, 'column_id') || [];
        const columns: Record<string, ConsignmentColumn> = {};
        options.forEach((item) => {
            columns[item.column_id] = item;
        });
        return (
            <Settings
                bucketSelected={bucketSelected}
                filterObject={{
                    columns,
                    filters: filterObject,
                }}
                onClose={(refresh?: boolean) => handleSettingsClose(refresh)}
            />
        );
    };

    const renderCancelModal = () => {
        if (!cancelVisible.visible) {
            return null;
        }

        return (
            <CancellationModal
                action={cancelVisible.action}
                consignments={consignmentsSelected}
                onClose={(success: boolean, params?: any) => {
                    setCancelVisible({
                        visible: false,
                    });
                    if (success) {
                        setToggle(!toggle);
                        if (params?.failures?.length) {
                            setFailures({
                                visible: true,
                                list: params.failures,
                            });
                        } else {
                            setConsignmentSelected([]);
                        }
                    }
                }}
            />
        );
    };

    const renderRescheduleModal = () => {
        if (!rescheduleVisible.visible || !rescheduleVisible.action) {
            return null;
        }

        return (
            <RescheduleModal
                action={rescheduleVisible.action}
                consignments={rescheduleVisible.consignments || []}
                onClose={(success: boolean, params?: any) => {
                    setRescheduleVisible({ visible: false });
                    if (success) {
                        setToggle(!toggle);
                        if (params?.failures?.length) {
                            setFailures({
                                visible: true,
                                list: params.failures,
                            });
                        } else {
                            setConsignmentSelected([]);
                        }
                    }
                }}
            />
        );
    };

    const renderCancelFailure = () => {
        if (!failures.visible || !failures?.list?.length) {
            return null;
        }

        return (
            <FailureList
                failureList={failures.list}
                onClose={() => setFailures({ visible: false })}
            />
        );
    };

    const renderPodDrawer = () => {
        if (!podConsignment?.id) {
            return null;
        }
        return (
            <ProofOfDelivery
                podConsignment={podConsignment}
                onClose={() => {
                    setPodConsignment({});
                }}
            />
        );
    };

    const renderSchedulePickupDrawer = () => {
        if (!scheduleVisible) {
            return null;
        }
        return (
            <SchedulePickupModal
                consignments={consignmentsSelected}
                onClose={(success: boolean, params?: any) => {
                    setScheduleVisible(false);
                    if (success) {
                        setToggle(!toggle);
                        if (params?.failures?.length) {
                            setFailures({
                                visible: true,
                                list: params.failures,
                            });
                        } else {
                            setConsignmentSelected([]);
                        }
                    }
                }}
            />
        );
    };

    const renderSettings = () => {
        return (
            <SettingOutlined
                className={classes.settingIcon}
                onClick={() => setSettingsVisible(true)}
            />
        );
    };

    const handlePagination = (nextOrPrev: NextOrPrev, resultPerPage?: number | undefined) => {
        const { currentPageNumber } = pagination;
        let newPageNumber = currentPageNumber;
        if (nextOrPrev === 'first') {
            newPageNumber = 1;
        } else if (nextOrPrev === 'next') {
            newPageNumber = currentPageNumber + 1;
        } else {
            newPageNumber = currentPageNumber - 1;
        }
        const newPagination = {
            ...pagination,
            nextOrPrev,
            currentPageNumber: newPageNumber,
        };
        if (resultPerPage) {
            newPagination.resultPerPage = Number(resultPerPage);
        }
        setpagination(Buckets.CONSIGNMENTS, newPagination);
        setToggle(!toggle);
    };

    const renderPaginator = () => {
        return (
            <div className={classes.paginationGroup}>
                <div>
                    {t('showing')}
                    <Select
                        className={classes.resultPerPage}
                        value={pagination.resultPerPage.toString()}
                        onChange={(val: string) => handlePagination('first', val as any)}
                        options={paginationOptions}
                        dropdownMatchSelectWidth={false}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    />
                    {t('rows_per_page')}
                </div>
                <Paginator
                    currentPageNumber={pagination.currentPageNumber}
                    isNextPresent={pagination.isNextPresent}
                    onNextClick={() => handlePagination('next')}
                    onPrevClick={() => handlePagination('prev')}
                    onFirstClick={() => handlePagination('first')}
                />
            </div>
        );
    };

    const renderFooter = () => {
        return (
            <div className={classes.footer}>
                {renderPaginator()}
            </div>
        );
    };

    const renderRefresh = () => {
        return (
            <Tooltip title={t('reload')}>
                <Button
                    size="small"
                    type="ghost"
                    style={{
                        color: uiTheme.primaryColor,
                        fontSize: 14,
                        marginRight: 12,
                    }}
                    onClick={() => {
                        handlePagination('first');
                        loadconsignments();
                    }}
                >
                    <ReloadOutlined />
                </Button>
            </Tooltip>
        );
    };

    const renderActions = () => (
        <>
            {renderProofDownload()}
            {!consignmentPageData && renderDownload()}
            {renderSchedulePickup()}
            {isCancelAllowed ? renderCancel() : null}
            {showReschedule ? renderReschedule() : null}
        </>
    );

    const renderActionsButton = () => {
        return (
            <Dropdown
                overlay={() => (
                    <Menu
                        style={{
                            ...ActionMenuStyle,
                            justifyContent: 'center',
                        }}
                    >
                        {renderActions()}
                    </Menu>
                )}
            >
                <Button
                    type="primary"
                    className={classes.actionButton}
                >
                    {t('actions')}
                </Button>
            </Dropdown>
        );
    };

    const onInputFieldSubmit = () => {
        const newFilters = {
            ...filters,
            referenceNumberList: undefined,
            customerReferenceNumberList: undefined,
            [selectedSearchType]: inputFilterVal || undefined,
        };
        setfilters(Buckets.CONSIGNMENTS, newFilters);
        applyfilters(Buckets.CONSIGNMENTS);
    };

    const handleSearchTypeChange = (value: string) => {
        if (inputFilterVal.trim()) {
            onInputFieldSubmit();
        }
        setSelectedSearchType(value);
    };

    const renderSearchType = () => {
        return (
            <div key="statusList">
                <Select
                    className={classes.searchSelect}
                    value={selectedSearchType}
                    onChange={((value) => handleSearchTypeChange(value))}
                    dropdownMatchSelectWidth={false}
                >
                    <Select.Option value="referenceNumberList">{t('consignment_number')}</Select.Option>
                    <Select.Option value="customerReferenceNumberList">{t('Customer_reference_number')}</Select.Option>
                </Select>
            </div>
        );
    };

    const renderSearch = () => {
        return (
            <Input
                value={inputFilterVal}
                placeholder={t(`${selectedSearchType}_placeholder`)}
                onChange={(e) => {
                    setInputFilterVal(e.target.value);
                }}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        onInputFieldSubmit();
                    }
                }}
                className={isMobile ? classes.mobileSearch : classes.search}
            />
        );
    };

    const renderRightFilters = () => {
        return (
            <div className={classes.rightFilters}>
                {renderSearchType()}
                {renderSearch()}
                {renderRefresh()}
                {renderPrint()}
                {renderActionsButton()}
                <Divider
                    type="vertical"
                    style={{
                        width: 1,
                        height: 24,
                        backgroundColor: '#E0E0E0',
                        borderRadius: 4,
                    }}
                />
                {viewIdToUse && (
                    <ViewToggle
                        viewMode={viewMode}
                        onViewModeChange={setViewMode}
                        viewIdFromConfig={viewIdToUse}
                    />
                )}
                {renderSettings()}
            </div>
        );
    };

    const renderExtraFilters = () => {
        return (
            <div className={classes.extraFilters}>
                {renderLeftFilters()}
                {renderRightFilters()}
            </div>
        );
    };

    const renderFilters = () => {
        return (
            <div className={classes.filters} ref={filtersRef}>
                <div style={{ display: 'flex' }}>
                    {renderBuckets()}
                    {renderDateFilter()}
                </div>
                {renderExtraFilters()}
            </div>
        );
    };

    const renderConsignmentDetailed = () => {
        if (!details) {
            return null;
        }
        return (
            <ConsignmentDetails
                referenceNumber={details}
                details={details}
                master={master}
                handleGoback={() => {
                    setDetails(undefined);
                    setToggle(!toggle);
                    history.push(`${getConsignmentsRoute()}`);
                }}
            />
        );
    };

    const renderTable = () => {
        const viewData = consignmentPageData?.getViewData(bucketSelected);
        const dataSource = (consignments || []).map((item: any) => {
            const { custom_fields = {}, ...rest } = item;
            return {
                ...rest,
                ...custom_fields,
            };
        });
        return (
            <FixedHeaderTable
                bordered={false}
                pagination={false}
                loading={loading || viewData?.isLoading}
                rowKey={(row: any) => row.reference_number}
                columns={getColumns()}
                style={{
                    flexGrow: 1,
                    background: '#ffffff',
                }}
                sortBy={filters.sortBy || filters.dateType}
                descendingOrder={filters.descendingOrder}
                rowSelection={{
                    onSelect: (row: any, selected: any) => {
                        let newArray = [...consignmentsSelected];
                        if (selected && !newArray.includes(row.reference_number)) {
                            newArray.push(row.reference_number);
                        } else {
                            newArray = newArray.filter((item) => (item !== row.reference_number));
                        }
                        setConsignmentSelected(newArray);
                    },
                    onSelectAll: (selected: any, selectedRows: any) => {
                        const newArray = selectedRows.map((item: any) => (item.reference_number));
                        setConsignmentSelected(newArray);
                    },
                    selectedRowKeys: consignmentsSelected,
                }}
                handleSort={handleColumnSort}
                dataSource={dataSource || []}
            />
        );
    };

    const renderMoreFilters = () => {
        if (!moreFilterVisible) {
            return null;
        }
        return (
            <MoreFilters
                resetVisible={isMoreFilterAdded()}
                config={config}
                bucketSelected={bucketSelected}
                onClose={() => setMoreFiltersVisible(false)}
            />
        );
    };

    const renderConsignmentPage = () => {
        if (pageSelected !== 'Consignments' || details) {
            return null;
        }

        if (viewMode) {
            const CustomView = getListView(viewMode);
            if (CustomView) {
                const viewData = consignmentPageData?.getViewData(bucketSelected);
                return (
                    <CustomView
                        master={master}
                        filters={filters}
                        setfilters={setfilters}
                        applyfilters={applyfilters}
                        fetchviewdata={fetchviewdata}
                        loading={loading || viewData?.isLoading}
                        consignments={consignments}
                        loadconsignments={loadconsignments}
                        summary={summary}
                        pagination={pagination}
                        setpagination={setpagination}
                        history={history}
                        defaultFilters={defaultFilters}
                        uiTheme={uiTheme}
                        consignmentPageData={consignmentPageData}
                        goToDetailsPage={goToDetailsPage}
                        viewMode={viewMode}
                        onViewModeChange={setViewMode}
                        viewIdFromConfig={viewIdToUse}
                        isMoreFilterAdded={isMoreFilterAdded}
                        handleResetFilters={handleResetFilters}
                    />
                );
            }
        }

        if (isMobile) {
            const viewData = consignmentPageData?.getViewData(bucketSelected);
            return (
                <ConsignmentPageMobile
                    loading={loading || viewData?.isLoading}
                    consignments={consignments}
                    pagination={pagination}
                    consignmentsSelected={consignmentsSelected}
                    setConsignmentSelected={setConsignmentSelected}
                    handlePagination={handlePagination}
                    actionMenu={actionMenu}
                    renderActions={renderActions}
                    setMoreFiltersVisible={setMoreFiltersVisible}
                    handleResetFilters={handleResetFilters}
                    renderSearch={renderSearch}
                    useMariaDb
                    handleDateChange={handleDateChange}
                    filters={filters}
                    statusOptions={statusOptions}
                    onStatusChange={(value: string | undefined) => onChangeFilter('statusList', value)}
                    goToDetailsPage={goToDetailsPage}
                    isMoreFilterAdded={isMoreFilterAdded}
                />
            );
        }
        return (
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                {renderFilters()}
                {renderTable()}
                {renderFooter()}
            </div>
        );
    };

    const renderPluginOrders = () => {
        if (pageSelected !== 'PluginOrders' || details || !enable_shopify_integration) {
            return null;
        }
        return (
            <>
                <PluginOrders />
            </>
        );
    };

    const renderExcelUpload = () => {
        if (pageSelected !== 'ExcelUpload' || !showMultipleCnSection) {
            return null;
        }
        return (
            <ExcelUpload
                goToPrintHistory={() => setPageSelected('PrintHistory')}
            />
        );
    };

    const renderPrintHistory = () => {
        if (pageSelected !== 'PrintHistory' || !showMultipleCnSection) {
            return null;
        }
        return <PrintHistory />;
    };

    const renderImage = () => {
        if (!imageUrl) return null;
        return (
            <Image
                src={imageUrl}
                width={0}
                preview={{
                    visible: !!imageUrl,
                    src: imageUrl,
                    onVisibleChange: (value) => {
                        if (!value) setImageUrl(null);
                    },
                }}
            />
        );
    };

    const renderSingleConsignment = () => {
        if (!editFormVisible) {
            return null;
        }
        const isConfigEnabled = master.config?.customer_portal_order_creation_config?.is_enabled;
        return (
            isConfigEnabled
                ? (
                    <SingleConsignmentNew
                        config={master}
                        onClose={() => setFormVisible(false)}
                        setSuccess={(data: any) => {
                            // eslint-disable-next-line no-console
                            console.log(data);
                            // TODO: handle success event
                            message.success('Consignment updated successfully');
                            setFormVisible(false);
                        }}
                        loadconsignments={loadconsignments}
                        editData={editData}
                    />
                )
                : (
                    <SingleConsignment
                        config={master}
                        onClose={() => setFormVisible(false)}
                        setSuccess={(data: any) => {
                            // eslint-disable-next-line no-console
                            console.log(data);
                            // TODO: handle success event
                            message.success('Consignment updated successfully');
                            setFormVisible(false);
                        }}
                        loadconsignments={loadconsignments}
                        editData={editData}
                    />
                )
        );
    };

    return (
        <div className={classes.main}>
            {renderConsignmentPage()}
            {renderPluginOrders()}
            {renderConsignmentDetailed()}
            {renderExcelUpload()}
            {renderPrintHistory()}
            {renderSettingsModal()}
            {renderSchedulePickupDrawer()}
            {renderCancelModal()}
            {renderRescheduleModal()}
            {renderCancelFailure()}
            {renderMoreFilters()}
            {renderPodDrawer()}
            {renderNotesDrawer()}
            {isGalleryModalVisible && (
                <GalleryModal
                    isVisible={isGalleryModalVisible}
                    imageVideoGalleryData={galleryModalData}
                    handleModalClose={() => { setIsGalleryModalVisible(false); }}
                />
            )}
            {isTextModalVisible && (
                <Modal
                    title={textModalData.title}
                    visible={isTextModalVisible}
                    onCancel={() => setIsTextModalVisible(false)}
                    width="35%"
                    footer={null}
                    centered
                >
                    {textModalData.text}
                </Modal>
            )}
            {
                isSupplementaryServiceTable && (
                    <TableModal
                        header="Supplementary Services"
                        isVisible={isSupplementaryServiceTable}
                        handleModalClose={() => {
                            setIsSupplementaryServiceTable(false);
                            setSupplementaryServiceData([]);
                        }}
                        dataSource={supplementaryServiceData}
                        useCustomGenerateDataColumns
                        columnsToShow={defaultColumnsForSupplementaryServices}
                        customGenerateDataColumns={getColumnsForSupplementaryServices}
                    />
                )
            }
            {renderImage()}
            {renderSingleConsignment()}
            {RenderUploadModal()}
            {renderLinkModal(modalRow)}
            {SuccessPopup()}
            {BulkPrintModal()}
            {renderConfirmationModal()}
        </div>
    );
};

const mapStateToProps = (state: ReduxStore) => {
    const {
        generic,
        master,
        uiTheme,
        genericPage,
    } = state;
    const { CONSIGNMENTS } = generic;
    const {
        loading,
        data,
        summary,
        pagination,
        appliedFilters,
        defaultFilters,
    } = CONSIGNMENTS;

    return {
        master,
        uiTheme,
        loading,
        summary,
        pagination,
        defaultFilters,
        filters: appliedFilters,
        consignments: data,
        consignmentPageData: genericPage[PAGE_NAMES.CONSIGNMENTS],
    };
};

const mapDispatchToProps = (dispatch: any) => {
    const actions = {
        setfilters: setFilters,
        applyfilters: applyFilters,
        loadconsignments: loadConsignments,
        setpagination: setPagination,
        fetchviewdata: fetchViewData,
    };
    return bindActionCreators(actions, dispatch);
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
        mapDispatchToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: consignemtStyles,
    },
    connectRouter: true,
    connectTranslession: true,
};

export default GenericHoc(hocConfig)(ConsignmentPage);
